import { Component, OnInit, inject } from '@angular/core';
import moment from 'moment';
import { firstValueFrom } from 'rxjs';
import { Icon_Image } from 'src/app/Constants/Constants-Global/Images-Icon';
import { Icon_Images } from 'src/app/Interfaces/Interfaces-Global/Icon_Images.interface';
import { Response_CCP } from 'src/app/Interfaces/Interfaces-Global/Response.interface';
import { Data_RecycleBin_CCP, Filter_Check_CCP_Recicle } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Data_RecycleBin.interface';
import { Filter_Check_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Filter_Check_CCP.interface';
import { Headers_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Headers-CCP.interface';
import { LIBRARYCCPService } from 'src/app/Services/Libraries/General-CCP/library-ccp.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-recycle-bin-file-ccp',
    templateUrl: './recycle-bin-file-ccp.component.html',
    styleUrls: ['./recycle-bin-file-ccp.component.scss', '../../../../../Styles/GlobalStyles.css', '../../../../../Styles/RecycleBin.scss'],
    standalone: false
})
export class RecycleBinFileCCPComponent implements OnInit {


  //+================== VARIABLES FOR HEADERS RB ==================+\\
  public HeadersRB: Headers_CCP[] = [
    { ID: 1, Name: 'Icono', Position: 1, Visible: true, Key_Header: 'ICONF' },
    { ID: 1, Name: 'Nombre', Position: 1, Visible: true, Key_Header: 'NAMFI' },
    { ID: 1, Name: 'Ubicación original', Position: 1, Visible: true, Key_Header: 'ROUTE' },
    { ID: 1, Name: 'Usuario que eliminó CCP', Position: 1, Visible: true, Key_Header: 'USEDE' },
    { ID: 1, Name: 'Fecha de eliminación', Position: 1, Visible: true, Key_Header: 'DATED' },
    { ID: 1, Name: '', Position: 1, Visible: true, Key_Header: 'DELET' },
  ]


  //+================== VARIABLES FOR SEARCH ==================+\\
  public Filter_RecycleBin: string = '';


  //+================== VARIABLE FOR ALL RECYCLE BIN CCP ==================+\\
  public List_RecycleBin: Data_RecycleBin_CCP[] = [];
  public SelectedList_RecycleBin: Data_RecycleBin_CCP[] = [];

  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';

  //+================== FOR FILTERS ==================+\\
  public Filter_Global_Check: Filter_Check_CCP_Recicle = {
    Extension: [],
    Model_Year: [],
    Status: [],
    Reviewer_Name: [],
    Approver_Name: [],
    Contributor_Name: [],
    Name_User_Deleted: []
  };

  //+================== VARIABLES FOR REGULAR EXPRESION ==================+\\
  private Expression1: RegExp = /[/]+[0-9]+§/

  //+================== VARIABLES FOR ICONS IMAGE ==================+\\
  public Icons_Image: Icon_Images[] = Icon_Image;

  //+================== VARIABLE FOR ALL VERSION CCP ==================+\\
  public LoadPage: boolean = false;


  //-========================= SERVICES =========================-\\
  private Service_CCP = inject(LIBRARYCCPService);

  ngOnInit(): void {
    this.Load_Component_RB();
  }



  //&===================== FUNCTIONS FOR LOAD COMPONENT =====================&\\

  private async Load_Component_RB(): Promise<void> {

    const Loader = document.getElementById('Loader') as HTMLDivElement;
    Loader.classList.add('active');

    try {
      this.List_RecycleBin = [];

      const ResRecycleBin: Response_CCP = await firstValueFrom(this.Service_CCP.Get_All_RecycleBin_CCP());

      if (ResRecycleBin.success) {
        this.List_RecycleBin = ResRecycleBin.operation;
      }

      Loader.classList.remove('active');
      this.LoadPage = true;

      this.Generate_Filters();


    } catch (e) {

      Swal.fire({
        title: 'Error',
        text: '¡Error al cargar la papelera de reciclaje, informa a tu supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })

      Loader.classList.remove('active');
      this.LoadPage = true;
    }

  }

  //&===================== END FUNCTIONS FOR LOAD COMPONENT =====================&\\





  //&===================== FUNCTION FOR RESTORE OR DELETED FILE OR DIRECTORY =====================&\\

  //-================== FUNCTION TO RESTORE A FILE OR DIRECTORY ==================-\\

  // ============== FUNCTION FOR VERIFY IF FILE SELECT IS FILE OR DIRECTORY ==============\\

  public Restore_File_Or_Directory(FileRecycle: Data_RecycleBin_CCP): void {

    FileRecycle.Directory ? this.Restore_Directory_CCP(FileRecycle) : (this.Restore_File_CCP(FileRecycle));

  }

  // ============== FUNCTION FOR RESTORE FILE CCP ==============\\
  private Restore_File_CCP(FileRecycle: Data_RecycleBin_CCP): void {

    Swal.fire({
      title: '¿Está seguro de restaurar el Proceso?',
      text: "¡No podrá recuperar el Proceso!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: '¡sí, restaurar!'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Nuevamente ¿está seguro?',
          text: `¡Marque la casilla para restaurar el Proceso!`,
          input: 'checkbox',
          inputPlaceholder: 'Restaurar Proceso',
          confirmButtonText: 'Continuar <i class="fa-solid fa-right-long"></i>',
          confirmButtonColor: this.ColorConfirm,
          cancelButtonColor: this.ColorsCancel,
          showCancelButton: true,
        }).then((async (result2: any) => {

          if (result.isConfirmed) {

            if (result2.value === 1) {

              try {

                const ResMoveRBin: Response_CCP = await firstValueFrom(this.Service_CCP.Restore_Process_CCP({ ID_CCP: FileRecycle.ID }));

                if (ResMoveRBin.success) {
                  Swal.fire({
                    icon: 'success',
                    title: `Proceso restaurado`,
                    text: `¡Se restauró correctamente el proceso!`,
                    confirmButtonColor: this.ColorConfirm
                  });

                  this.Load_Component_RB();
                }


              } catch (e) {
                Swal.fire({
                  icon: 'warning',
                  title: `Error al restaurar el proceso`,
                  text: `¡No se restauró el proceso, notifica a tu supervisor!`,
                  confirmButtonColor: this.ColorConfirm
                });

                this.Load_Component_RB();


              }

            } else {
              Swal.fire({
                icon: 'warning',
                title: 'Sin confirmar',
                text: '¡Marque la casilla para restaurar el Proceso!',
                confirmButtonColor: this.ColorConfirm
              });

            }

          }


        }))
      }
    })

  }

  // ============== FUNCTION FOR RESTORE DIRECTORY ==============\\
  private Restore_Directory_CCP(FileRecycle: Data_RecycleBin_CCP): void {

    const NameRestore: string = (FileRecycle.Name).trim();

    Swal.fire({
      title: '¿Está seguro de restaurar el directorio?',
      text: "¡No podrá revertir cambios!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: '¡Sí, restaurar!'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Nuevamente ¿está seguro?',
          text: `¡Para restaurar el directorio escriba ${NameRestore} !`,
          input: 'text',
          confirmButtonText: 'Continuar <i class="fa-solid fa-right-long"></i>',
          confirmButtonColor: this.ColorConfirm,
          cancelButtonColor: this.ColorsCancel,
          showCancelButton: true,
        }).then((async result2 => {

          if (result2.isConfirmed) {

            const ValueInput: string = result2.value;

            if (ValueInput.toLowerCase() === NameRestore.toLowerCase()) {

              try {

                const ResDeleteDir: Response_CCP = await firstValueFrom(this.Service_CCP.Restore_Directory_CCP({ ID_Folder: FileRecycle.ID }));

                if (ResDeleteDir.success) {
                  Swal.fire({
                    icon: 'success',
                    title: `Directorio restaurado`,
                    text: `¡Se restauró correctamente el directorio!`,
                    confirmButtonColor: this.ColorConfirm
                  });
                  this.Load_Component_RB();
                }


              } catch (e) {
                Swal.fire({
                  icon: 'warning',
                  title: `Error al restaurar el directorio`,
                  text: `¡No se restauró el directorio, notifica a tu supervisor!`,
                  confirmButtonColor: this.ColorConfirm
                });
                this.Load_Component_RB();
              }

            } else {
              Swal.fire({
                icon: 'warning',
                title: 'Sin coincidencia',
                text: '¡Escriba correctamente el nombre del directorio para restaurarlo!',
                confirmButtonColor: this.ColorConfirm
              })
            }
          }
        }))
      }
    })
  }


  //-================== FUNCTION TO DELETE A FILE OR DIRECTORY ==================-\\

  // ============== FUNCTION FOR VERIFY IF FILE SELECT IS FILE OR DIRECTORY ==============\\
  public Delete_File_or_Directory(FileRecycle: Data_RecycleBin_CCP): void {

    FileRecycle.Directory ? (this.Delete_Directory_Permanently_CCP(FileRecycle)) : (this.Delete_File_Permanently_CCP(FileRecycle));

  }

  // ============== FUNCTION FOR DELETE FILE CCP ==============\\
  private Delete_File_Permanently_CCP(FileRecycle: Data_RecycleBin_CCP): void {

    Swal.fire({
      title: '¿Está seguro de eliminar el Proceso permanentemente?',
      text: "¡No podrá recuperar el Proceso!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: '¡sí, eliminar permanentemente!'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Nuevamente ¿está seguro?',
          text: `¡Marque la casilla para eliminar permanentemente el Proceso!`,
          input: 'checkbox',
          inputPlaceholder: 'Eliminar Proceso permanentemente',
          confirmButtonText: 'Continuar <i class="fa-solid fa-right-long"></i>',
          confirmButtonColor: this.ColorConfirm,
          cancelButtonColor: this.ColorsCancel,
          showCancelButton: true,
        }).then((async (result2: any) => {

          if (result2.isConfirmed) {

            if (result2.value === 1) {

              try {

                const ResMoveRBin: Response_CCP = await firstValueFrom(this.Service_CCP.Delete_Permanently_File_CCP({ ID_CCP: FileRecycle.ID }));

                if (ResMoveRBin.success) {
                  Swal.fire({
                    icon: 'success',
                    title: `Proceso eliminado permanentemente`,
                    text: `¡Se eliminó correctamente el proceso!`,
                    confirmButtonColor: this.ColorConfirm
                  });

                  this.Load_Component_RB();
                }


              } catch (e) {
                Swal.fire({
                  icon: 'warning',
                  title: `Error al eliminar el proceso`,
                  text: `¡No se eliminó el proceso, notifica a tu supervisor!`,
                  confirmButtonColor: this.ColorConfirm
                });

                this.Load_Component_RB();


              }

            } else {
              Swal.fire({
                icon: 'warning',
                title: 'Sin confirmar',
                text: '¡Marque la casilla para eliminar el Proceso!',
                confirmButtonColor: this.ColorConfirm
              });

            }

          }


        }))
      }
    })

  }

  // ============== FUNCTION FOR DELETE DIRECTORY ==============\\
  private Delete_Directory_Permanently_CCP(FileRecycle: Data_RecycleBin_CCP): void {

    const NameDelete: string = (FileRecycle.Name).trim();

    Swal.fire({
      title: '¿Está seguro de eliminar el directorio permanentemente?',
      text: "¡No podrá revertir cambios!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: '¡sí, eliminar permanentemente!'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Nuevamente ¿está seguro?',
          text: `¡Para eliminar permanentemente la carpeta escriba ${NameDelete} !`,
          input: 'text',
          confirmButtonText: 'Continuar <i class="fa-solid fa-right-long"></i>',
          confirmButtonColor: this.ColorConfirm,
          cancelButtonColor: this.ColorsCancel,
          showCancelButton: true,
        }).then((async result2 => {

          if (result2.isConfirmed) {

            const ValueInput: string = result2.value;

            if (ValueInput.toLowerCase() === NameDelete.toLowerCase()) {

              try {

                const ResDeleteDir: Response_CCP = await firstValueFrom(this.Service_CCP.Delete_Permanently_Dir_CCP({ ID_Folder: FileRecycle.ID }));

                if (ResDeleteDir.success) {
                  Swal.fire({
                    icon: 'success',
                    title: `Directorio eliminado permanentemente`,
                    text: `¡Se eliminó correctamente el directorio!`,
                    confirmButtonColor: this.ColorConfirm
                  });
                  this.Load_Component_RB();
                }


              } catch (e) {
                Swal.fire({
                  icon: 'warning',
                  title: `Error al eliminar el directorio`,
                  text: `¡No se eliminó el directorio, notifica a tu supervisor!`,
                  confirmButtonColor: this.ColorConfirm
                });
                this.Load_Component_RB();
              }

            } else {
              Swal.fire({
                icon: 'warning',
                title: 'Sin coincidencia',
                text: '¡Escriba correctamente el nombre del directorio para eliminarlo!',
                confirmButtonColor: this.ColorConfirm
              })
            }
          }
        }))
      }
    })
  }

  //&===================== END FUNCTION FOR RESTORE OR DELETED FILE OR DIRECTORY =====================&\\





  //&===================== FUNCTIONS FOR GENERAL COMPONENT =====================&\\

  //-================== FUNCTION FOR FILTERS ==================-\\
  private Generate_Filters(): void {

    this.Filter_Global_Check = {
      Extension: [],
      Model_Year: [],
      Status: [],
      Reviewer_Name: [],
      Approver_Name: [],
      Contributor_Name: [],
      Name_User_Deleted: [],
    };

    for (const CCP of this.List_RecycleBin as any) {

      CCP.Date_Created = moment(CCP.Date_Created).utc().toDate();
      CCP.Date_Expiration = moment(CCP.Date_Expiration).utc().toDate();

      if (!this.Filter_Global_Check.Extension.includes(CCP.Extension) && CCP.Extension !== null) {
        this.Filter_Global_Check.Extension.push(CCP.Extension);
      }

      if (!this.Filter_Global_Check.Name_User_Deleted.includes(CCP.Name_User) && CCP.Name_User !== null) {
        this.Filter_Global_Check.Name_User_Deleted.push(CCP.Name_User);
      }

    }


  }

  //-============== FUNCTION FOR FORMAT DATE DELETED ==============-\\
  public Get_Date_Deleted(Date_Deleted: Date | null): string {
    return moment(Date_Deleted).utc().format('DD/MM/YYYY hh:mm:ss a')
  }

  //-================ FUNCTION FOR CLEAN ROUTE ================-\\
  public Clean_Route(Route: string): string {

    const Route_Add: string = '/RAIZ/' + Route;

    const Route_Clean: string = Route_Add.split(this.Expression1).join('/');

    return Route_Clean.replace('/', '');
  }

  //&===================== END FUNCTIONS FOR GENERAL COMPONENT =====================&\\


}

